// extracted by mini-css-extract-plugin
export default {"userCell":"styles_userCell__aAO2I"};